/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AvailableHelperDto } from '../../models/available-helper-dto';

export interface PosSessionsControllerSearchAvailableHelpers$Params {
  page?: number;
  limit?: number;

/**
 * Search by first name, last name, or full name
 */
  search?: string;
}

export function posSessionsControllerSearchAvailableHelpers(http: HttpClient, rootUrl: string, params?: PosSessionsControllerSearchAvailableHelpers$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<AvailableHelperDto>>> {
  const rb = new RequestBuilder(rootUrl, posSessionsControllerSearchAvailableHelpers.PATH, 'get');
  if (params) {
    rb.query('page', params.page, {});
    rb.query('limit', params.limit, {});
    rb.query('search', params.search, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<AvailableHelperDto>>;
    })
  );
}

posSessionsControllerSearchAvailableHelpers.PATH = '/pos/sessions/available-helpers';
